import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "firebaseApp";
import SimpleMarkdownEditor from "components/ai-editor/SimpleMarkdownEditor";
import SectionContainer from "components/ai-editor/SectionContainer";
import AITextEditMenuItem from "components/ai-editor/AITextEditMenuItem";

export const MARKDONW_TYPE = {
  key: "markdown",
  default: {
    text: "",
  },
};

export default function Markdown({ section, dragHandleProps }) {

  const [markdown, setMarkdown] = useState(section.text);
  const [saving, setSaving] = useState(false);

  const save = async (text) => {
    try {
      setSaving(true);
      await updateDoc(
        doc(db, "documents", section.documentId, "sections", section.id),
        {
          text,
        }
      );
    } catch(error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  const setText = (text) => {
    setMarkdown(text);
    save(text);
  }

  return (
    <SectionContainer
      section={section}
      dragHandleProps={dragHandleProps}
      menuItems={[
        <AITextEditMenuItem
          text={markdown}
          setText={setText}
        />
      ]}
      saving={saving}
    >
      <SimpleMarkdownEditor
        value={markdown}
        setValue={setMarkdown}
        onBlur={() => save(markdown)}
        onTogglePreview={() => save(markdown)}
      />
    </SectionContainer>
  );
}
